import React, { useState, useEffect } from "react";
import PageInstructions from "@/components/PageInstructions";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import jsPDF from 'jspdf';

const SeteGruposDezenas = () => {
  const [dateOption, setDateOption] = useState("today");
  const [customDate, setCustomDate] = useState("");
  const [manualDay, setManualDay] = useState("");
  const [selectedPremio, setSelectedPremio] = useState("");
  const [showResults, setShowResults] = useState(false);
  const [resultData, setResultData] = useState<{dia: number; premio: string; grupos: number[]} | null>(null);
  const [todayDay, setTodayDay] = useState(new Date().getDate());

  const bichos: {[key: number]: string} = {
    1: 'Avestruz', 2: 'Águia', 3: 'Burro', 4: 'Borboleta', 5: 'Cachorro',
    6: 'Cabra', 7: 'Carneiro', 8: 'Camelo', 9: 'Cobra', 10: 'Coelho',
    11: 'Cavalo', 12: 'Elefante', 13: 'Galo', 14: 'Gato', 15: 'Jacaré',
    16: 'Leão', 17: 'Macaco', 18: 'Porco', 19: 'Pavão', 20: 'Peru',
    21: 'Touro', 22: 'Tigre', 23: 'Urso', 24: 'Veado', 25: 'Vaca'
  };

  const getDezenas = (grupo: number): string[] => {
    const base = (grupo - 1) * 4;
    return [
      String(base + 1).padStart(2, '0'),
      String(base + 2).padStart(2, '0'),
      String(base + 3).padStart(2, '0'),
      String(base + 4).padStart(2, '0')
    ];
  };

  const gruposPorDia: {[key: number]: number[]} = {
    1: [21, 23, 25, 1, 3, 5, 7],
    2: [19, 21, 23, 25, 1, 3, 9],
    3: [23, 25, 1, 3, 5, 7, 9],
    4: [23, 25, 1, 3, 5, 7, 9],
    5: [25, 1, 3, 5, 7, 9, 11],
    6: [1, 3, 5, 7, 9, 11, 13],
    7: [1, 3, 5, 7, 9, 11, 13],
    8: [1, 3, 5, 7, 9, 11, 13],
    9: [3, 5, 7, 9, 11, 13, 15],
    10: [5, 7, 9, 11, 13, 15, 17],
    11: [5, 7, 9, 11, 13, 15, 17],
    12: [7, 9, 11, 13, 15, 17, 19],
    13: [7, 9, 11, 13, 15, 17, 19],
    14: [9, 11, 13, 15, 17, 19, 21],
    15: [9, 11, 13, 15, 17, 19, 21],
    16: [11, 13, 15, 17, 19, 21, 23],
    17: [11, 13, 15, 17, 19, 21, 23],
    18: [13, 15, 17, 19, 21, 23, 25],
    19: [13, 15, 17, 19, 21, 23, 25],
    20: [15, 17, 19, 21, 23, 25, 1],
    21: [15, 17, 19, 21, 23, 25, 1],
    22: [17, 19, 21, 23, 25, 1, 3],
    23: [17, 19, 21, 23, 25, 1, 3],
    24: [19, 21, 23, 25, 1, 3, 5],
    25: [19, 21, 23, 25, 1, 3, 5],
    26: [21, 23, 25, 1, 3, 5, 7],
    27: [23, 25, 1, 3, 5, 7, 9],
    28: [25, 1, 3, 5, 7, 9, 11],
    29: [1, 3, 5, 7, 9, 11, 13],
    30: [3, 5, 7, 9, 11, 13, 15],
    31: [5, 7, 9, 11, 13, 15, 17]
  };

  useEffect(() => {
    const hoje = new Date();
    setTodayDay(hoje.getDate());
  }, []);

  const gerarGrupos = () => {
    if (!selectedPremio) {
      alert('Por favor, selecione um prêmio!');
      return;
    }

    let dia: number;

    if (dateOption === 'today') {
      dia = todayDay;
    } else if (dateOption === 'custom') {
      if (!customDate) {
        alert('Por favor, selecione uma data!');
        return;
      }
      dia = new Date(customDate).getDate();
    } else if (dateOption === 'manual') {
      const dayNum = parseInt(manualDay);
      if (!dayNum || dayNum < 1 || dayNum > 31) {
        alert('Por favor, digite um dia válido (1-31)!');
        return;
      }
      dia = dayNum;
    } else {
      return;
    }

    const grupos = gruposPorDia[dia];
    setResultData({ dia, premio: selectedPremio, grupos });
    setShowResults(true);
  };

  const exportData = () => {
    if (!showResults || !resultData) {
      alert('⚠️ Primeiro gere os grupos para poder exportar!');
      return;
    }

    const doc = new jsPDF();
    const currentDate = new Date().toLocaleString('pt-BR');
    
    doc.setFontSize(20);
    doc.text('Técnica dos 7 Grupos - Relatório', 20, 20);
    
    doc.setFontSize(12);
    doc.text(`Data de Exportação: ${currentDate}`, 20, 35);
    doc.text(`Dia selecionado: ${resultData.dia}`, 20, 45);
    doc.text(`Prêmio escolhido: ${resultData.premio}º Prêmio`, 20, 55);
    
    let yPos = 75;
    doc.setFontSize(14);
    doc.text('Grupos Gerados:', 20, yPos);
    yPos += 15;
    
    resultData.grupos.forEach((grupo, index) => {
      const dezenas = getDezenas(grupo);
      doc.setFontSize(10);
      doc.text(`${grupo.toString().padStart(2, '0')} - ${bichos[grupo]}: ${dezenas.join(', ')}`, 20, yPos);
      yPos += 12;
    });
    
    doc.save(`7_grupos_dia_${resultData.dia}_${new Date().toISOString().split('T')[0]}.pdf`);
    alert('📤 PDF exportado com sucesso!');
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      gerarGrupos();
    }
  };

  return (
    <div className="w-full space-y-6">
      <PageInstructions
        title="📖 Como usar a Técnica dos 7 Grupos"
        steps={[
          "Veja qual é o dia do mês hoje — cada dia tem 7 grupos específicos",
          "O sistema já destaca automaticamente os grupos do dia atual",
          "Verifique quais desses 7 grupos NÃO saíram nos últimos 2-3 dias",
          "Aposte nos grupos que estão em atraso — são os mais propensos a sair",
          "Exporte em PDF para ter a tabela completa do mês inteiro"
        ]}
      />
      {/* Header */}
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold bg-gradient-to-r from-purple-600 to-indigo-700 bg-clip-text text-transparent">
          🎯 Técnica dos 7 Grupos
        </h1>
        <p className="text-xl text-muted-foreground">Sistema Diário para Jogo do Bicho</p>
      </div>

      {/* Description */}
      <Card className="border-l-4 border-l-purple-600 bg-gradient-to-r from-slate-50 to-gray-50">
        <CardContent className="p-6">
          <p className="text-gray-700 leading-relaxed">
            <strong className="text-gray-800">Como funciona:</strong> Esta técnica define 7 grupos específicos para cada dia do mês. Os grupos são selecionados estrategicamente, incluindo repetições propositais para cercar todos os bichos ímpares. Escolha apenas o prêmio onde o grupo não foi sorteado nos últimos 2-3 dias.
          </p>
        </CardContent>
      </Card>

      {/* Warning */}
      <Card className="border-2 border-yellow-300 bg-gradient-to-r from-yellow-50 to-amber-50">
        <CardContent className="p-4 text-center">
          <p className="text-yellow-800 font-bold">
            ⚠️ ATENÇÃO: Escolha apenas o prêmio que o grupo não foi sorteado nos últimos dois ou três dias!
          </p>
        </CardContent>
      </Card>

      {/* Input Section */}
      <Card className="border-2 border-purple-200 bg-gradient-to-br from-purple-50 to-indigo-50">
        <CardHeader>
          <CardTitle className="text-purple-600 text-xl text-center">📅 Selecione o Dia</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Date Options */}
          <div className="flex justify-center gap-4 flex-wrap">
            {[
              { value: 'today', label: '🗓️ Hoje', icon: '🗓️' },
              { value: 'custom', label: '📆 Data Específica', icon: '📆' },
              { value: 'manual', label: '✏️ Dia Manual', icon: '✏️' }
            ].map((option) => (
              <label
                key={option.value}
                className={`flex items-center gap-2 p-3 rounded-full cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-lg ${
                  dateOption === option.value
                    ? 'bg-purple-600 text-white shadow-lg'
                    : 'bg-white shadow-md hover:bg-purple-50'
                }`}
              >
                <input
                  type="radio"
                  name="dateOption"
                  value={option.value}
                  checked={dateOption === option.value}
                  onChange={(e) => {
                    setDateOption(e.target.value);
                    setShowResults(false);
                  }}
                  className="sr-only"
                />
                <span>{option.label}</span>
              </label>
            ))}
          </div>

          {/* Date Input */}
          <div className="flex justify-center items-center gap-4 flex-wrap">
            {dateOption === 'today' && (
              <div className="text-xl font-bold text-gray-800">
                Hoje é dia {todayDay.toString().padStart(2, '0')}
              </div>
            )}
            
            {dateOption === 'custom' && (
              <input
                type="date"
                value={customDate}
                onChange={(e) => {
                  setCustomDate(e.target.value);
                  setShowResults(false);
                }}
                className="p-3 border-2 border-purple-300 rounded-lg text-center font-bold text-gray-800 bg-white focus:outline-none focus:ring-2 focus:ring-purple-400"
              />
            )}
            
            {dateOption === 'manual' && (
              <input
                type="number"
                placeholder="Digite o dia (1-31)"
                min="1"
                max="31"
                value={manualDay}
                onChange={(e) => {
                  setManualDay(e.target.value);
                  setShowResults(false);
                }}
                onKeyPress={handleKeyPress}
                className="p-3 border-2 border-purple-300 rounded-lg text-center font-bold text-gray-800 bg-white focus:outline-none focus:ring-2 focus:ring-purple-400"
              />
            )}
          </div>

          {/* Prize Selector */}
          <div className="space-y-3">
            <div className="text-center font-bold text-gray-800">🏆 Selecione o Prêmio para Apostar</div>
            <div className="flex justify-center gap-3 flex-wrap">
              {['1', '2', '3', '4', '5'].map((premio) => (
                <button
                  key={premio}
                  onClick={() => {
                    setSelectedPremio(premio);
                    setShowResults(false);
                  }}
                    className={`px-4 py-2 rounded-full font-bold transition-all duration-300 ${
                    selectedPremio === premio
                      ? 'bg-gradient-to-r from-purple-600 to-indigo-700 text-white'
                      : 'bg-white border-2 border-gray-300 hover:border-purple-600 hover:scale-105 text-gray-800'
                  }`}
                >
                  {premio}º Prêmio
                </button>
              ))}
            </div>
          </div>

          {/* Generate Button */}
          <Button
            onClick={gerarGrupos}
            className="w-full bg-gradient-to-r from-purple-600 to-indigo-700 hover:from-purple-700 hover:to-indigo-800 text-white py-4 text-lg font-bold rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-lg"
          >
            🎲 Gerar Grupos do Dia
          </Button>
        </CardContent>
      </Card>

      {/* Results */}
      {showResults && resultData && (
        <div className="space-y-6 animate-in slide-in-from-bottom-4 duration-500">
          {/* Groups Card */}
          <Card className="border-0">
            <CardContent className="p-0">
              <div className="bg-gradient-to-r from-orange-400 to-pink-500 text-white p-6 rounded-t-lg">
                <h3 className="text-2xl font-bold text-center mb-4">
                  🎯 Grupos para o Dia {resultData.dia.toString().padStart(2, '0')}
                </h3>
                
                <div className="bg-white/20 backdrop-blur-sm p-4 rounded-xl mb-5 text-center space-y-2">
                  <div><strong>📅 Dia selecionado:</strong> {resultData.dia}</div>
                  <div><strong>🏆 Prêmio escolhido:</strong> {resultData.premio}º Prêmio</div>
                  <div><strong>🎪 Total de grupos:</strong> 7 grupos para apostar</div>
                  <div><strong>⚠️ Lembre-se:</strong> Verifique se o grupo não saiu nos últimos 2-3 dias!</div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                  {resultData.grupos.map((grupoNum) => {
                    const dezenas = getDezenas(grupoNum);
                    return (
                      <div
                        key={grupoNum}
                        className="bg-white/90 text-slate-700 p-5 rounded-xl text-center shadow-lg"
                      >
                        <div className="text-2xl font-bold mb-2 text-pink-500">
                          {grupoNum.toString().padStart(2, '0')}
                        </div>
                        <div className="text-lg font-bold mb-3">
                          {bichos[grupoNum]}
                        </div>
                        <div className="flex justify-center gap-1 flex-wrap">
                          {dezenas.map((dezena) => (
                            <span
                              key={dezena}
                              className="bg-gray-100 px-2 py-1 rounded text-xs font-bold"
                            >
                              {dezena}
                            </span>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Strategy Info */}
          <Card className="border-0">
            <CardContent className="p-0">
              <div className="bg-gradient-to-r from-cyan-400 to-blue-500 text-white p-6 rounded-lg">
                <h3 className="text-2xl font-bold text-center mb-4">💡 Dicas da Estratégia</h3>
                
                <div className="bg-white/20 backdrop-blur-sm p-5 rounded-xl space-y-3">
                  <p><strong>🎯 Observação:</strong> Alguns bichos se repetem propositalmente para cercar todos os bichos ímpares.</p>
                  <p><strong>📊 Recomendação:</strong> Analise os últimos 2-3 sorteios antes de escolher o prêmio.</p>
                  <p><strong>🎪 Modalidades:</strong> Pode jogar nas dezenas ou no grupo completo.</p>
                  <p><strong>⚡ Estratégia:</strong> Foque no prêmio onde os grupos estão mais atrasados.</p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Export Button */}
          <Card className="border-2 border-green-200 bg-gradient-to-br from-green-50 to-emerald-50">
            <CardContent className="p-6 text-center">
              <Button
                onClick={exportData}
                className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-8 py-3 text-lg font-bold rounded-xl"
              >
                📤 Exportar PDF
              </Button>
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  );
};

export default SeteGruposDezenas;